import './RankingPage.css';
import RankingTable from './RankingTable';
import RankingMenu from "./RankingMenu";
import { Permissions } from '../../context/permissions';
import { useUser } from '../../context/UserContext';

const RankingPage = () => {
  const { userProfile } = useUser();
  return (
    <div className='page'>
      <div className='pageHeader'>Ranking</div>
      
      {userProfile?.permissions?.includes(Permissions.MANAGE_RANKING) && (
        <div className='pageMenu'>
          <RankingMenu />
        </div>
      )}
      
      <div>
        <RankingTable></RankingTable>
      </div>
    </div>
  );
};

export default RankingPage;
